module.exports = __webpack_public_path__ + "img/a-2.a8252834.png";